import React, { useEffect, useRef, useState } from 'react';

const OpalCountVisual = ({ chartConfig, chartData, chartOptions, columnSize, rowSize, palettes, themes, chartPalettes }) => {

    const [total, setTotal] = useState(0);
    const [dataList, setDataList] = useState([]);

    useEffect(() => {
        if (Array.isArray(chartData) && chartData.length > 0) {
            const firstItem = chartData[0];
            setTotal(firstItem.Total ?? 0);
            setDataList(firstItem.Data ?? []);
        }
    }, [chartConfig, chartData])

    return (
        <div className='chart-content'>
            <div className='d-flex align-items-center justify-content-center h-100'
                style={{
                    fontFamily: 'Lato-semibold',
                    fontSize: '3rem',
                    color: chartConfig.binding.data.value === "Pending" ? "#DD6C6C" : "#000"
                }}>
                {total}
            </div>
        </div>
    );
};

export default OpalCountVisual;
